import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    disabled: _ctx.disabled,
    class: "el_get_code",
    onClick: _ctx.getCodeClick
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.get_code_hinder), 1)
    ]),
    _: 1
  }, 8, ["disabled", "onClick"]))
}